export interface AvatarColor {
  bgColor: string;
  textColor: string;
  hoverBgColor: string;
  hoverTextColor: string;
}

export const avatarColorPalette: AvatarColor[] = [
  { bgColor: "#DEE3E7", textColor: "#272E35", hoverBgColor: "#555F6D", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FCDEC0", textColor: "#7A4510", hoverBgColor: "#F59638", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FCD9D9", textColor: "#6F2020", hoverBgColor: "#C53434", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FBD5E2", textColor: "#671E36", hoverBgColor: "#C03060", hoverTextColor: "#FFFFFF" },
  { bgColor: "#FBD5EE", textColor: "#671E4E", hoverBgColor: "#B12F86", hoverTextColor: "#FFFFFF" },
  { bgColor: "#F5D5FB", textColor: "#5B1E67", hoverBgColor: "#9939AC", hoverTextColor: "#FFFFFF" },
  { bgColor: "#EDDBFF", textColor: "#4C2277", hoverBgColor: "#8040BF", hoverTextColor: "#FFFFFF" },
  { bgColor: "#E3E0FF", textColor: "#39288A", hoverBgColor: "#634ECA", hoverTextColor: "#FFFFFF" },
  { bgColor: "#D7E4FF", textColor: "#113997", hoverBgColor: "#3062D4", hoverTextColor: "#FFFFFF" },
  { bgColor: "#CCE7FF", textColor: "#0C456E", hoverBgColor: "#0870BA", hoverTextColor: "#FFFFFF" },
  { bgColor: "#C5ECF7", textColor: "#0A495C", hoverBgColor: "#077597", hoverTextColor: "#FFFFFF" },
  { bgColor: "#C5F2EC", textColor: "#0D4A42", hoverBgColor: "#097C69", hoverTextColor: "#FFFFFF" },
  { bgColor: "#C6F1DA", textColor: "#0E4E30", hoverBgColor: "#1D7C4D", hoverTextColor: "#FFFFFF" },
  { bgColor: "#CFF2CF", textColor: "#135315", hoverBgColor: "#347434", hoverTextColor: "#FFFFFF" },
];
